export const actionTypes = {
  GET_CODES: 'GET_CODES',
  GET_CODES_SUCCESS: 'GET_CODES_SUCCESS',
};

export const getCodes = () => ({
  type: actionTypes.GET_CODES,
});

export const getCodesSuccess = data => ({
  type: actionTypes.GET_CODES_SUCCESS,
  payload: data,
});
